<template>
    <div class="col-md-6 col-xl-3 box-col-6">
        <div class="card">
                        <div class="blog-box blog-grid text-center product-box">
                            <div class="product-img"><img class="img-fluid top-radius-blog"
                                    :src=" data.linkimg " alt="">
                                <div class="product-hover">
                                    <a :href="data.link"  target="_blank">
                                        <ul>

                                            <li v-if="data.type == 'link'" >
                                                <i class="icon-link"></i>
                                            </li>
                                            <li v-if="data.type =='file'">                                              
                                                <i class="icon-import"></i>                                         
                                            </li>

                                        </ul>
                                    </a>

                                </div>
                            </div>
                            <div class="blog-details-main">
                                <!--
                                <ul class="blog-social">
                                    <li class="digits">2022/10/18</li>
                                </ul>
                                <hr>
                                -->
                                <h6 class="blog-bottom-details">
                                    <div v-html="data.title">

                                    </div>
                                </h6>
                            </div>
                        </div>
                    </div>
    </div>

</template>
<script>
export default{
    props:{
        data:[]
    },

}
</script>
